<app-page-header title="Verksamhetskategori" icon="hotel"></app-page-header>
<div [@fadeInOut] class="page-content">
  <form #form="ngForm" [formGroup]="businessCategoryForm" (ngSubmit)="save()" novalidate fxLayout="column" fxLayoutGap="1em" autocomplete="off">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Namn</mat-label>
            <input matInput formControlName="name" required />
            @if (getFormControl('name').hasError('required')) {
              <mat-error>Namn är obligatoriskt</mat-error>
            }
            @if (getFormControl('name').hasError('maxlength')) {
              <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
            }
          </mat-form-field>
          <div class="flex-1">
            <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
          </div>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Beskrivning</mat-label>
            <textarea matInput rows="4" formControlName="description"></textarea>
          </mat-form-field>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Krav ej uppfyllda - Beskrivning</mat-label>
            <textarea matInput rows="8" formControlName="requirementsNotFulfilledDescription"></textarea>
          </mat-form-field>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Krav uppfyllda - Beskrivning</mat-label>
            <textarea matInput rows="8" formControlName="requirementsFulfilledDescription"></textarea>
          </mat-form-field>
        </div>
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1" [hidden]="isNew">
              <mat-label>Skapad av</mat-label>
              <input matInput [readonly]="true" value="{{ createdByName$ | async }}" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Skapad</mat-label>
              <input matInput formControlName="createdDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew && changedByName$) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad av</mat-label>
              <input matInput [readonly]="true" value="{{ changedByName$ | async }}" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad</mat-label>
              <input matInput formControlName="updatedDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Id</mat-label>
              <input matInput formControlName="businessCategoryId" [readonly]="true" />
            </mat-form-field>
            <div class="flex-1">
            </div>
          </div>
        }
      </mat-card-content>
      <mat-card-actions>
        <section class="button-container">
          @if (hasPermissionToChange()) {
            <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
          }
          <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
        </section>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
